import { render, staticRenderFns } from "./NoticeHighlight.vue?vue&type=template&id=150f07d2&scoped=true"
import script from "./NoticeHighlight.vue?vue&type=script&lang=js"
export * from "./NoticeHighlight.vue?vue&type=script&lang=js"
import style0 from "./NoticeHighlight.vue?vue&type=style&index=0&id=150f07d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f07d2",
  null
  
)

export default component.exports